import React, { useContext, useState,PureComponent } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import Input from '../components/forms/Input';
import Button from '../components/forms/Button';
import { initializeApp } from "firebase/app";
import {setToLocalStorage} from '../components/helper/auth'
import {
    GoogleAuthProvider,
    getAuth,
    signInWithPopup,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    signOut,
    sendEmailVerification,
} from "firebase/auth";
import {
    getFirestore,
    query,
    getDocs,
    collection,
    where,
    addDoc,
} from "firebase/firestore";
import { firebaseConfig } from "../firebaseConfig"
import { AuthContext } from '../context/auth';
import { useNavigate,Link } from 'react-router-dom';

export default function Login() {
  
    const [authc, setAuth] = useContext(AuthContext);
    console.log(authc)
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate=useNavigate();
    const app = initializeApp(firebaseConfig);
    const auth = getAuth();
    const [loading, setLoading] = useState();

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {      
        signInWithEmailAndPassword(auth, email, password).then(async (userCredential) => {
              toast.success("Welcome back")
              setAuth(userCredential.user)
              setToLocalStorage("auth",userCredential.user)
              setTimeout(()=>{
                  navigate('/dashboard')
              },2000)
              
          }).catch((error) => {
            setLoading(false)
              toast.error("Signin Unsuccessful ")
              const errorCode = error.code; 
              const errorMessage = error.message;
          });
      } catch (error) {
          setLoading(false)
          console.log(error);
      }
  }
    return (

      <div style={{ margin: "100px" }} className='d-flex justify-content-center align-items-center vh-100' >
          <Toaster />
          <div className='container'>
              <div className='row'>
                  <div className='col-md-6 offset-md-3'>
                      <h1 className='fw-bold mb-3'>Login</h1>

                      <form>
                          <Input value={email} setValue={setEmail} label="Email" type="email" />
                          <Input value={password} setValue={setPassword} label="Password" type="password" />
                          <Button handleSubmit={handleSubmit} 
                                    className={"btn btn-primary" }
                                    type={"submit"}
                                    text={"Submit"}
                                    email={email}
                                    password={password} 
                                    loading={loading}/>
                      </form>
                      <p className='mt-3'><Link to={"/forgot-password"}>Forgot password</Link> </p> 
                  </div>

              </div>

          </div>

          <pre>                       {JSON.stringify({ email, password,}, null, 4)}</pre>

      </div>
  )

  }

